var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.field.label))]),_c('DatePicker',{attrs:{"inputAttributes":{class: 'form-control'}},model:{value:(_vm.field.val),callback:function ($$v) {_vm.$set(_vm.field, "val", $$v)},expression:"field.val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }